function getCustomAxis(width, domainPadding) {
  return function customAxis(g) {
    g.attr('font-family', null);
    g.selectAll('.domain').remove();
    g.selectAll('g:last-of-type').remove();
    g
      .selectAll('line')
      .attr('x1', width + domainPadding * 2)
      .attr('stroke-dasharray', '2 4')
      .attr('stroke', '#CCC');
    g
      .selectAll('text')
      .style('font-size', d => {
        if (window.matchMedia('(min-width: 600px)').matches) {
          return '0.75rem';
        }
        return '1.5rem';
      })
      .style('fill', '#404040')
      .attr('class', 'y-label')
      .attr('text-anchor', 'start')
      .attr('dx', -5)
      .attr('x', 0);
  };
}

export default getCustomAxis;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/getCustomAxis.js